<template>
  <div
    class="tab-pane"
    id="shiftsettings"
    role="tabpanel"
    aria-labelledby="shiftsettings-tab"
    ref="formContainer"
  >
    <!--<h4>Expense Approval Settings</h4> -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-5">
          <Form @submit="updateShiftSettings">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Weekly Hours Threshold
                <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="form.weekly_threshold"
              />
            </div>

            <!-- Start Day of Week Field -->
            <div class="input-block mb-3">
              <label class="col-form-label mb-2"
                >Start Day of Week <span class="text-danger">*</span></label
              >

              <div class="days-container d-flex flex-wrap">
                <div class="day-option me-3 mb-2">
                  <input
                    type="radio"
                    v-model="form.start_day_of_week"
                    id="sunday"
                    value="Sunday"
                    class="btn-check"
                  />
                  <label class="btn btn-outline-light" for="sunday"
                    >Sunday</label
                  >
                </div>
                <div class="day-option me-3 mb-2">
                  <input
                    type="radio"
                    v-model="form.start_day_of_week"
                    id="monday"
                    value="Monday"
                    class="btn-check"
                  />
                  <label class="btn btn-outline-light" for="monday"
                    >Monday</label
                  >
                </div>
                <div class="day-option me-3 mb-2">
                  <input
                    type="radio"
                    v-model="form.start_day_of_week"
                    id="tuesday"
                    value="Tuesday"
                    class="btn-check"
                  />
                  <label class="btn btn-outline-light" for="tuesday"
                    >Tuesday</label
                  >
                </div>
                <div class="day-option me-3 mb-2">
                  <input
                    type="radio"
                    v-model="form.start_day_of_week"
                    id="wednesday"
                    value="Wednesday"
                    class="btn-check"
                  />
                  <label class="btn btn-outline-light" for="wednesday"
                    >Wednesday</label
                  >
                </div>
                <div class="day-option me-3 mb-2">
                  <input
                    type="radio"
                    v-model="form.start_day_of_week"
                    id="thursday"
                    value="Thursday"
                    class="btn-check"
                  />
                  <label class="btn btn-outline-light" for="thursday"
                    >Thursday</label
                  >
                </div>
                <div class="day-option me-3 mb-2">
                  <input
                    type="radio"
                    v-model="form.start_day_of_week"
                    id="friday"
                    value="Friday"
                    class="btn-check"
                  />
                  <label class="btn btn-outline-light" for="friday"
                    >Friday</label
                  >
                </div>
                <div class="day-option me-3 mb-2">
                  <input
                    type="radio"
                    v-model="form.start_day_of_week"
                    id="saturday"
                    value="Saturday"
                    class="btn-check"
                  />
                  <label class="btn btn-outline-light" for="saturday"
                    >Saturday</label
                  >
                </div>
              </div>
            </div>

            <!-- Standard Pay to Overtime Field -->
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Standard Pay to Overtime (x times)
                <span class="text-danger">*</span></label
              >
              <input
                type="number"
                class="form-control"
                v-model="form.standard_pay_to_overtime"
                min="1"
                max="10"
                step="0.1"
              />
              <!-- <small class="text-muted">Enter a value between 1x to 10x</small> -->
            </div>

            <div class="submit-section" v-if="hasEditPermission">
              <button class="btn btn-primary submit-btn">Save Changes</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { notification } from "ant-design-vue";
import { Form } from "vee-validate";
export default {
  components: {
    Form,
  },
  data() {
    return {
      select2: null,
      Approver: [
        "Select Approvers",
        "CEO",
        "Direct Manager",
        "Development Manager",
        "Finance",
      ],
      Approvers1: [
        "Select Approvers",
        "CEO",
        "Direct Manager",
        "Development Manager",
        "Finance",
      ],
      Approvers2: [
        "Select Approvers",
        "CEO",
        "Direct Manager",
        "Development Manager",
        "Finance",
      ],
      form: {
        weekly_threshold: 40,
        start_day_of_week: "Monday",
        standard_pay_to_overtime: 1.5,
      },
      hasEditPermission: null,
    };
  },
  methods: {
    updateShiftSettings() {
      console.log("called update");

      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .post("/globalsettings/updatevisibilitysettings", this.form)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.loadCommonData([]);
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadCommonData(params) {
      console.log("common data loading called..");

      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.$refs.formContainer,
      //   canCancel: false,
      // });

      axios
        .get("/globalsettings/shiftsettings", params)
        .then((response) => {
          if (response.data.data.length) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.form[response.data.data[i].global_settings_key] =
                response.data.data[i].global_settings_value;
            }
          }

          console.log(this.form);
          // loader.hide();
        })
        .catch((error) => {
          // loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", {
        module: "global_setting",
        action: "write",
      })
      .then((response) => {
        this.hasEditPermission = null;
        this.$nextTick(() => {
          this.hasEditPermission = response === "true";
        });
      });

    this.loadCommonData([]);
  },
};
</script>
<style scoped>
.days-container {
  gap: 0.5rem;
}

.day-option {
  position: relative;
}

.btn-check:checked + .btn-outline-light {
  background-color: #ff9b44;
  color: white;
  border-color: #ff9b44;
}

.btn-outline-light {
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check + :hover {
  background-color: #ff9b44;
  color: white;
  border-color: #ff9b44;
}
</style>
